import * as Factory from 'factory.ts'

import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import {
  type QuickBooksFieldMapConstructor,
  QuickBooksFieldMap,
} from './QuickBooksFieldMap'
import { QuickBooksFieldMapModels } from '../enums/QuickBooksFieldMapModelEnum'
import { QuickBooksFieldMappingRowConstructorFactory } from '../QuickBooksFieldMappingRow'

export const QuickBooksFieldMapConstructorFactory =
  Factory.Sync.makeFactory<QuickBooksFieldMapConstructor>({
    model: QuickBooksFieldMapModels.PURCHASE_ORDER,
    rows: Factory.each(() => [
      QuickBooksFieldMappingRowConstructorFactory.build(),
    ]),
  })

export const QuickBooksFieldMapFactory = EntityFactory(
  QuickBooksFieldMap,
  QuickBooksFieldMapConstructorFactory
)
